var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"question"},[_c('div',{staticClass:"body",domProps:{"innerHTML":_vm._s(_vm.selected_question.question_content)}}),_vm._v(" "),_c('div',{staticClass:"answer",class:[
      _vm.selected_question.is_correct_answer ? 'correct' : 'incorrect',
    ]},[_vm._v("\n      "+_vm._s(_vm.selected_question.answer_content)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }